import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'datetime',
    standalone: true,
})
export class DateTimePipe extends DatePipe implements PipeTransform {
    transform(value: string | number | Date, format?: string, timezone?: string, locale?: string): string;
    transform(value: null, format?: string, timezone?: string, locale?: string): null;
    transform(value: string | number | Date, format?: string, timezone?: string, locale?: string): string;
    transform(
        value: string | number | Date | null,
        format: string = 'medium',
        timezone?: string,
        locale?: string,
    ): string | null {
        if (!value) {
            return null;
        }

        let resultDate = value;

        if (typeof value === 'string') {
            let temp = new Date(value);
            if (value.indexOf('Z') == -1) {
                temp = new Date(value + 'Z');
            }

            // TODO refactor of timezone offset
            let offset = temp.getTimezoneOffset() / 30;

            resultDate = new Date(
                Date.UTC(
                    temp.getFullYear(),
                    temp.getMonth(),
                    temp.getDate(),
                    temp.getHours() + offset,
                    temp.getMinutes(),
                ),
            );
        }

        return super.transform(resultDate, format, timezone, locale);
    }
}
